module.exports = __webpack_public_path__ + "static/media/Lateral_End Stage_Z2.6e4a8059.png";